import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { AdminGuard } from './auth/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  { path: 'forgot', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  { path: 'reset', loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) },
  { path: 'new-password', loadComponent: () => import('./pages/new-password/new-password.component').then(m => m.NewPasswordComponent) },
  {
    path: 'account',
    canMatch: [AuthGuard],
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent)
  },
  { path: 'profile', redirectTo: 'account', pathMatch: 'full' },
  {
    path: 'users-csr',
    loadComponent: () => import('./pages/users-csr/users-csr.component').then(m => m.UsersCsrComponent)
  },
  {
    path: 'users-csr/:id',
    canMatch: [AuthGuard],
    loadComponent: () => import('./pages/user-csr-detail/user-csr-detail.component').then(m => m.UserCsrDetailComponent)
  },
  {
    path: 'users-ssr',
    loadComponent: () => import('./pages/users-ssr/users-ssr.component').then(m => m.UsersSsrComponent)
  },
  {
    path: 'users-prerender',
    loadComponent: () => import('./pages/users-prerender/users-prerender.component').then(m => m.UsersPrerenderComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'api-info',
    loadComponent: () => import('./pages/api-info/api-info.component').then(m => m.ApiInfoComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'queue-stats',
    loadComponent: () => import('./pages/queue-stats/queue-stats-page.component').then(m => m.QueueStatsPageComponent)
  },
  {
    path: 'history',
    canMatch: [AuthGuard],
    loadComponent: () => import('./components/history/history.component').then(m => m.HistoryComponent)
  },
  {
    path: 'results/:jobid',
    canMatch: [AuthGuard],
    loadComponent: () => import('./pages/results/results.component').then(m => m.ResultsComponent)
  },
  {
    path: 'admin',
    canMatch: [AdminGuard],
    loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent)
  }
];
